import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography } from '@comparethemarketau/manor-typography';
import { connect } from 'react-redux';
import { capitalize } from 'lodash';

import { vehicleMake, vehicleYear, vehicleModel, applicantFirstName, getProductCategory } from '../../../../core/state_selectors';
import { withAvailableQuotes } from '../../products/common/with_available_quotes';

const _SummarySubTitle = (props) => {
    const { make, availableQuotesSize, coverType, year, model, className } = props;

    const productWording = `product${availableQuotesSize > 1 ? 's' : ''}`;

    const availableQuotesWording = `Here's ${availableQuotesSize} ${coverType.toLowerCase()} cover ${productWording} for your ${year} ${capitalize(make)} ${capitalize(model)}.`;
    const noQuotesWording = `No quotes received from our providers for your ${year} ${capitalize(make)} ${capitalize(model)}.`;
    return (
        <Typography className={classNames('test-policySummary-subTitle', className)}>
            {availableQuotesSize > 0 ? availableQuotesWording : noQuotesWording}
        </Typography>
    );
};

_SummarySubTitle.propTypes = {
    className: PropTypes.string,
    make: PropTypes.string,
    year: PropTypes.string,
    model: PropTypes.string,
    availableQuotesSize: PropTypes.number,
    coverType: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        make: vehicleMake({ state }),
        year: vehicleYear({ state }),
        model: vehicleModel({ state }),
        firstName: applicantFirstName({ state }),
        coverType: getProductCategory(state)
    };
};

const SummarySubTitle = withAvailableQuotes(connect(mapStateToProps)(_SummarySubTitle));

export { SummarySubTitle, _SummarySubTitle };
